import React, { useState } from 'react';
import '../../static/css/Layout/ContactModal.css';

export default function ContactModal({ onClose }) {
    const [form, setForm] = useState({
        contactName: '',
        email: '',
        reason: 'General',
        message: '',
    });

    const [submitted, setSubmitted] = useState(false);

    const CONTACT_SUBMISSION = 'https://admin.nectrstudio.com/items/contact_submissions';


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch(CONTACT_SUBMISSION, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    contact_name: form.contactName,
                    email: form.email,
                    reason: form.reason,
                    message: form.message,
                })
            });

            if (res.ok) {
                setSubmitted(true);
            } else {
                alert("Something went wrong. Please try again.");
            }
        } catch (err) {
            alert("Something went wrong. Please try again.");
        }
    };

    return (
        <div className="modal-overlay">
            <div className="contact-modal-content">
                <button className="modal-close" onClick={onClose}>×</button>

                {!submitted ? (
                    <>
                        <h2>Contact Us</h2>
                        <form onSubmit={handleSubmit} className="contact-form">
                            <label>
                                Name*
                                <input
                                    type="text"
                                    required
                                    value={form.contactName}
                                    onChange={(e) => setForm({ ...form, contactName: e.target.value })}
                                />
                            </label>

                            <label>
                                Email*
                                <input
                                    type="email"
                                    required
                                    value={form.email}
                                    onChange={(e) => setForm({ ...form, email: e.target.value })}
                                />
                            </label>

                            <label>
                                Reason
                                <select
                                    value={form.reason}
                                    onChange={(e) => setForm({ ...form, reason: e.target.value })}
                                >
                                    <option>General</option>
                                    <option>Billing</option>
                                    <option>Cancel Subscription</option>
                                    <option>Technical Support</option>
                                </select>
                            </label>

                            <label>
                                Message*
                                <textarea
                                    rows="4"
                                    required
                                    value={form.message}
                                    onChange={(e) => setForm({ ...form, message: e.target.value })}
                                />
                            </label>

                            <button type="submit" className="btn btn-accent-primary">Send</button>
                        </form>
                    </>
                ) : (
                    <div className="contact-success">
                        <h2>Thanks for reaching out!</h2>
                        <p>We’ve received your message and will get back to you shortly.</p>
                        <button className="btn btn-accent-primary mt-3" onClick={onClose}>Close</button>
                    </div>
                )}
            </div>
        </div>
    );
}
